import { useState } from "react";

window.customLocalStorage=
{
    getItem(key)
    {
        // getting the data from localStorage using the key
        let result=JSON.parse(window.localStorage.getItem(key));

        if(result)
        {
            /*
                if data expireTime is less then current time
                means item has expired,
                in this case removing the item using the key
                and return the null.
            */
            if(result.expireTime<=Date.now())
            {
                window.localStorage.removeItem(key);
                return null;
            }
            // else return the data.
            return result.data;
        }
        //if there is no data provided the key, return null.
        return null;
    },

    /*
        accepting the key, value and expiry time as a parameter
        default expiry time is 30 days in milliseconds.
    */
    setItem(key, value, maxAge=30*60*60*1000)
    {
        // Storing the value in object.
        let result=
        {
            data:value
        }

        if(maxAge)
        {
            /*
                setting the expireTime currentTime + expiry Time
                provided when method was called.
            */
            result.expireTime=Date.now()+maxAge;
        }
        window.localStorage.setItem(key,JSON.stringify(result));
    },
    removeItem(key)
    {
        window.localStorage.removeItem(key);
    },
    clear()
    {
        window.localStorage.clear();
    }
}


export const useLocalStorage = (keyName, defaultValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.customLocalStorage.getItem(keyName);
      if (value) {
        return JSON.parse(value);
      } else {
        window.customLocalStorage.setItem(keyName, JSON.stringify(defaultValue), 3*24*60*60*1000);
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });
  const setValue = (newValue) => {
    try {
      window.customLocalStorage.setItem(keyName, JSON.stringify(newValue), 3*24*60*60*1000);
    } catch (err) {}
    setStoredValue(newValue);
  };
  return [storedValue, setValue];
};